import { Component, Inject, OnInit } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { isMobile, UtilityService } from "@core/utility.service";
import { Popover } from "@interfaces/popover.enum";
import { ITimer } from "@interfaces/timer";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { LottieComponent } from "ngx-lottie";
import { interval, Observable, Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { HomeDataService } from "src/app/services/home-data.service";
import { ClarityService } from "src/app/services/clarity.service";
import { AddHomeScreenComponent } from "../add-home-screen/add-home-screen.component";
import { QuickAccessComponent } from "../quick-access/quick-access.component";


@Component({
    selector: "app-joined-syndicate",
    templateUrl: "./joined-syndicate.component.html",
    styleUrls: ["./joined-syndicate.component.scss"],
    standalone: true,
    imports: [
        LottieComponent,
        IonicModule,
        MatProgressSpinner,
        MatIcon,
        TranslatePipe,
    ],
})
export class JoinedSyndicateComponent implements OnInit {
  spinnerAnimation: boolean;
  progressBar = 5;
  proceed = true;
  timer$: Observable<number>;
  sub: Subscription;
  $timer: ITimer;
  constructor(
    private window: Window,
    private bottomSheet: MatBottomSheet,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<JoinedSyndicateComponent>,
    public translate: TranslateService,
    private authService: AuthService,
    private homeDataService: HomeDataService,
    private clarityService: ClarityService,
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {
    this.setupSyndicateStatus();
  }

  close() {
    this.dialog.close(false);
    if (isMobile.iOS()) {
      this.checkIfUserIsOnStandAlone();
    } else if (isMobile.Android()) {
      this.addHomeScreen();
    }
  }
  // below this method is used to show bottom sheet if the user using the app in android
  private setupSyndicateStatus() {
    const syndicatePopupShown = localStorage.getItem(Popover.syndicatePopupShown) === Popover.isTrue;
    if (UtilityService.isAppInstalledOnHomePage() || syndicatePopupShown) {
      return;
    }
    this.homeDataService
      .getAddHomePopupStatus().subscribe((syndicateStatus) => {
      const data = syndicateStatus as Data;
      if (!data?.syndicate) {
        if (isMobile.Android()) {
          const addHomeScreen = this.bottomSheet.open(AddHomeScreenComponent, {
            panelClass: "add-home-popup-bottomSheet",
            hasBackdrop: true,
            disableClose: true,
            data: syndicateStatus,
          });
          addHomeScreen?.afterDismissed()?.subscribe((data) => {
            if (data) {
              this.homeDataService.hideHomeScreenPopup(Popover.syndicate);
            }
          });
        } else if (isMobile.iOS()) {
          if (
            navigator.vendor &&
            navigator.vendor.indexOf("Apple") > -1 &&
            navigator.userAgent &&
            navigator.userAgent.indexOf("CriOS") == -1 &&
            navigator.userAgent.indexOf("FxiOS") == -1
          ) {
            const addHomeScreen = this.bottomSheet.open(QuickAccessComponent, {
              panelClass: "quick-popup-bottomSheet",
              hasBackdrop: true,
              disableClose: true,
              data: syndicateStatus
            });
            addHomeScreen?.afterDismissed()?.subscribe((data) => {
              if (data) {
                this.homeDataService.hideHomeScreenPopup(Popover.syndicate)
              }
            });
          } else {
            this.authService.getConstantsMsg(Popover.Id_1043).then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "The app works best on Safari browser",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle success.png",
                    type: "Success",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
                this.homeDataService.hideHomeScreenPopup(Popover.syndicate);
              })
              .catch((error) => {
                return error;
              });
          }

        }
      }
      localStorage.setItem(Popover.syndicatePopupShown, Popover.isTrue);
    });
  }

  viewTickets() {
    setTimeout(() => {
      this.dialog.close(true);
    }, 5000);
  }

  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(50);
    this.sub = this.timer$.subscribe(
      (sec) => {
        if (this.progressBar == 50) {
          this.sub?.unsubscribe();
          this.timer$ = interval(90);
          this.sub = this.timer$.subscribe(() => {
            this.progressBar = this.progressBar + 1;
            if (this.progressBar == 75) {
              this.sub?.unsubscribe();
              this.timer$ = interval(120);
              this.sub = this.timer$.subscribe(() => {
                this.progressBar = this.progressBar + 1;
                this.spinnerAnimation = false;
                this.proceed= false;
              });
            }
          });
        }
        this.progressBar = 0 + sec;
      },
      (err) => {
        this.proceed= true;
        return err;
      }
    );
  }
  // The addHomeScreen method is used to  add-home-screen-bottomSheet on addHomeScreen

  addHomeScreen() {
    const syndicatePopupShown = localStorage.getItem(Popover.syndicatePopupShown) === Popover.isTrue;
    if (UtilityService.isAppInstalledOnHomePage() || syndicatePopupShown) {
      return;
    }
    if (this.window["customEvent"]) {
      const addHomeScreen = this.bottomSheet.open(AddHomeScreenComponent, {
        panelClass: "add-home-popup-bottomSheet",
      });

      addHomeScreen?.afterDismissed()?.subscribe((data) => {
        if (data) {
          this.window["customEvent"].prompt();
          this.window["customEvent"].userChoice.then();
        }
      });
      localStorage.setItem(Popover.syndicatePopupShown, Popover.isTrue);
    }
  }
  quickAccess() {
    this.bottomSheet.open(QuickAccessComponent, {
      panelClass: "quick-popup-bottomSheet",
    });
  }

  // The checkIfUserIsOnStandAlone method is used to check if the user is using IOS
  checkIfUserIsOnStandAlone() {
    const syndicatePopupShown = localStorage.getItem(Popover.syndicatePopupShown) === Popover.isTrue;
    if (UtilityService.isAppInstalledOnHomePage() || syndicatePopupShown) {
      return;
    } else {
      if (isMobile.iOS()) {
        if (
          navigator.vendor &&
          navigator.vendor.indexOf("Apple") > -1 &&
          navigator.userAgent &&
          navigator.userAgent.indexOf("CriOS") == -1 &&
          navigator.userAgent.indexOf("FxiOS") == -1
        ) {
          this.authService?.userDetails$?.pipe(take(1))?.subscribe((data: Data) => {
            if (!data?.installed_last_auto_login_date) {
              setTimeout(() => {
                this.quickAccess();
              }, 5000);
              return;
            }
            let today = moment().format("YYYY-MM-DD");
            let past = moment(data?.installed_last_auto_login_date?.toDate()).format("YYYY-MM-DD");
            let gap = moment(today).diff(moment(past), "days");

            if (gap > 14) {
              setTimeout(() => {
                this.quickAccess();
              }, 5000);
            }

            return;
          });
        } else {
          /* const msg = this.translatedToastMsg?.["1043"]?.[this.selectedLanguage];
          this.authService.showToast(msg ? msg : "Code Error", "Success", ""); */
          this.authService.getConstantsMsg(Popover.Id_1043).then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "The app works best on Safari browser",
                  line_2: "",
                },
                style: {
                  icon: "tick circle success.png",
                  type: "Success",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            })
            .catch((err) => {
              return err;
            });
        }
      }
      localStorage.setItem(Popover.syndicatePopupShown, Popover.isTrue);
    }
  }

}
